import { http } from '../../../../api/http';
import type { ConfiguracionPlanilla } from '../types/configuracion';

const ENDPOINT = '/planilla/configuracion';

export class ConfiguracionService {
  static async get(): Promise<ConfiguracionPlanilla> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async save(config: ConfiguracionPlanilla): Promise<ConfiguracionPlanilla> {
    const response = await http.post(ENDPOINT, config);
    return response.data;
  }
}
